export enum AnaliticsTableType {
  MouseTrapsAnalytics = 'Mouse traps analytics',
  RatTrapsAnalytics = 'Rat traps analytics',
  SmartRodentBaitModule = 'Smart rodent bait modules analytics',
  Vulnerabilities = 'Vulnerabilities/PCCs analytics',
  Sights = 'Pest sightings analytics',
}
